import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "./Reveal";

export default function BannerSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="banner-quote"
      className="relative flex h-[420px] items-center justify-center overflow-hidden bg-navy-900"
    >
      <motion.div style={{ y }} className="absolute inset-x-0 -bottom-[15%] -top-[15%]">
        <img
          src="/images/girls-highfive-banner.webp"
          alt="Two friends celebrating at sunset above the islands of Clew Bay"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-navy-950/45" />
      <div className="relative z-10 px-5 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 1, ease: EASE }}
          className="font-serif text-4xl font-medium italic text-ivory drop-shadow-lg sm:text-6xl"
        >
          Travel. Discover. <span className="text-gold">Learn.</span>
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 1, delay: 0.25, ease: EASE }}
          className="mt-4 text-[11px] font-semibold uppercase tracking-[0.34em] text-ivory/85"
        >
          Welcome to the adventure of a lifetime
        </motion.p>
      </div>
    </section>
  );
}
